import PropTypes from 'prop-types';

const data = PropTypes.shape({
  choices: PropTypes.arrayOf(PropTypes.string),
  disabledText: PropTypes.string,
  givenAnswer: PropTypes.arrayOf(PropTypes.string),
  questionType: PropTypes.string,
  isGradable: PropTypes.bool,
  isPractice: PropTypes.bool,
  questionId: PropTypes.number,
  required: PropTypes.bool,
  saveUrl: PropTypes.string,
  subject: PropTypes.string,
});

const meta = PropTypes.shape({
  elementHeaderClass: PropTypes.string,
  labelErrorClass: PropTypes.string,
  questionSubjectClass: PropTypes.string,
});

export const IMultipleSelectProps = {
  data,
  meta,
};
